module.exports = __webpack_public_path__ + "img/work_schedule.b4bbf0c6.svg";